import * as numeros from '../util/numeros'

import * as texto from '../util/texto'


export function validaCpf(valor){

    let aux = numeros.formatarSomenteNum(valor)

    if(texto.isBlanck(aux))
        return false;

    return aux.length==11;
}


export function formataCnpj(valor){

    return texto.isBlanck(valor)?"":valor.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
}


export function formataCpf(valor){

    return texto.isBlanck(valor)?"":valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
}


export function formataCep(valor){

    return texto.isBlanck(valor)?"":valor.replace(/^(\d{5})(\d{3})/, "$1-$2")
}


export function formataMoeda(valor){

    let aux = String(valor);

    return texto.isBlanck(aux)?"0,00":aux.replace('.', ',')
}


export function formataCnpjCpf(valor){

    return texto.isBlanck(valor)?"":(valor.length==11?formataCpf(valor):formataCnpj(valor))
}


export function formataFone(fone){

    if(texto.isBlanck(fone))
        return "";

    if(fone.length<=2)
        return fone

    const aux = fone.substring(2)

    if(aux.length<=4)
        return "("+fone.substring(0,2)+") "+aux;

    if(aux.length<=8)
        return "("+fone.substring(0,2)+") "+aux.substring(0,4)+"-"+aux.substring(4);

    return "("+fone.substring(0,2)+") "+aux.substring(0,5)+"-"+aux.substring(5);
}


export function validarDataEua(data) {
   
    const regex = /^(\d{4})-(\d{2})-(\d{2})$/;

    if (!regex.test(data))
        return false;
    
    const [ano, mes, dia] = data.split('-').map(num => parseInt(num, 10));

    const dataObjeto = new Date(ano, mes - 1, dia);

    if (dataObjeto.getFullYear() !== ano || dataObjeto.getMonth() + 1 !== mes || dataObjeto.getDate() !== dia)
        return false;
    
    return true;
}







